import FilterSales from './filterSales'

export default FilterSales
